import Carousel, { slidesToShowPlugin, arrowsPlugin } from '@brainhubeu/react-carousel'
import { Box, Container, Divider, Icon, Typography } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import iconOrderFinished from 'assets/images/icon-orderFinished.svg'
import iconShop from 'assets/images/icon-shop.svg'
import { IItem, ISeparation } from 'interfaces/ISeparation'
import { useEffect, useState } from 'react'
import { BsPersonBadgeFill } from 'react-icons/bs'
import { FaClock, FaShoppingCart, FaUserCheck } from 'react-icons/fa'
import { formatName } from 'utils/formatName'

import { useStyles } from './styles'
import { MdVisibility } from 'react-icons/md'

interface ISummaryOrderProps {
  textTotal: string
  textCompleted: string
  textPedding: string
  textTimer: string
  textSeparator: string
  textConferencer: string
  textRevision: string
  totalItens: number
  completed: number
  className?: string
  itensPending: IItem[]
  separations: ISeparation[]
  startSeparation?: Date
  separatorName?: string
  conferencerName?: string
  isReviwed?: string
}

export const SummaryOrder = (props: ISummaryOrderProps) => {
  const {
    completed,
    totalItens,
    textCompleted,
    textPedding,
    textTotal,
    textTimer,
    textSeparator,
    textConferencer,
    textRevision,
    className,
    itensPending,
    separations,
    startSeparation,
    separatorName,
    conferencerName,
    isReviwed,
  } = props

  const stepWithItem = separations.find(separation => separation.items.length > 0)
  const separationTime = stepWithItem?.items[0]?.work?.working_time_secs

  const [index, setIndex] = useState(0)
  const classes = useStyles()
  const [width, setWidth] = useState(() => window?.innerWidth)
  const [elapsedTime, setElapsedTime] = useState(0)

  useEffect(() => {
    if (!startSeparation) return

    const interval = setInterval(() => {
      const now = new Date().getTime()
      const start = new Date(startSeparation).getTime()
      setElapsedTime(Math.floor((now - start) / 1000))
    }, 1000)

    return () => clearInterval(interval)
  }, [startSeparation])

  const formatElapsedTime = (seconds: number) => {
    const h = String(Math.floor(seconds / 3600)).padStart(2, '0')
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0')
    const s = String(seconds % 60).padStart(2, '0')
    return `${h}:${m}:${s}`
  }

  const renderTimer = () => {
    if (separationTime) {
      return (
        <strong style={{ textAlign: 'right' }}>
          {new Date(separationTime * 1000).toISOString().substr(11, 8)}
        </strong>
      )
    }
    if (startSeparation) {
      return <strong style={{ textAlign: 'right' }}>{formatElapsedTime(elapsedTime)}</strong>
    }
    return <strong style={{ textAlign: 'right' }}>00:00:00</strong>
  }

  useEffect(() => {
    const updateWidth = (e: any) => {
      setWidth(e.target?.innerWidth)
    }

    window.addEventListener('resize', updateWidth)

    return () => {
      window.removeEventListener('resize', updateWidth)
    }
  }, [])

  if (width <= 1050) {
    return (
      <Carousel
        className={`${classes.carousel} ${className}`}
        value={index}
        onChange={e => {
          if (e >= 0) {
            setIndex(e)
          }
        }}
        plugins={[
          {
            resolve: slidesToShowPlugin,
            options: {
              numberOfSlides: 4,
            },
          },
        ]}
        breakpoints={{
          1050: {
            plugins: [
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 3,
                },
              },
              {
                resolve: arrowsPlugin,
                options: {
                  arrowLeft: (
                    <button className={classes.arrowLeft}>
                      <ArrowBackIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowLeftDisabled: (
                    <button disabled={true} className={classes.arrowLeft}>
                      <ArrowBackIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowRight: (
                    <button className={classes.arrowRight}>
                      <ArrowForwardIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowRightDisabled: (
                    <button disabled={true} className={classes.arrowRight}>
                      <ArrowForwardIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  addArrowClickHandler: true,
                },
              },
            ],
          },
          820: {
            plugins: [
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 2,
                },
              },
              {
                resolve: arrowsPlugin,
                options: {
                  arrowLeft: (
                    <button className={classes.arrowLeft}>
                      <ArrowBackIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowLeftDisabled: (
                    <button disabled={true} className={classes.arrowLeft}>
                      <ArrowBackIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowRight: (
                    <button className={classes.arrowRight}>
                      <ArrowForwardIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowRightDisabled: (
                    <button disabled={true} className={classes.arrowRight}>
                      <ArrowForwardIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  addArrowClickHandler: true,
                },
              },
            ],
          },
          520: {
            plugins: [
              {
                resolve: slidesToShowPlugin,
                options: {
                  numberOfSlides: 1,
                },
              },
              {
                resolve: arrowsPlugin,
                options: {
                  arrowLeft: (
                    <button className={classes.arrowLeft}>
                      <ArrowBackIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowLeftDisabled: (
                    <button disabled={true} className={classes.arrowLeft}>
                      <ArrowBackIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowRight: (
                    <button className={classes.arrowRight}>
                      <ArrowForwardIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  arrowRightDisabled: (
                    <button disabled={true} className={classes.arrowRight}>
                      <ArrowForwardIosIcon className={classes.arrowIcon} />
                    </button>
                  ),
                  addArrowClickHandler: true,
                },
              },
            ],
          },
        }}
      >
        <div style={{ display: 'flex' }}>
          <Box className={classes.box}>
            <span className={`${classes.icon} ${classes.totalOrderIcon}`}>
              <FaShoppingCart size={28} color="#fff" />
            </span>
            <div>
              <Typography className={classes.title}>{textTotal}</Typography>
              <Typography className={classes.subtitle}>{totalItens}</Typography>
            </div>
          </Box>
        </div>
        <div style={{ display: 'flex' }}>
          <Divider className={classes.divider} orientation="vertical" flexItem />
          <Box className={classes.box}>
            <span className={`${classes.icon} ${classes.ordersFinished}`}>
              <img src={iconOrderFinished} />
            </span>
            <div>
              <Typography className={classes.title}>{textCompleted}</Typography>
              <Typography className={classes.subtitle}>{completed}</Typography>
            </div>
          </Box>
          <Divider className={classes.divider} orientation="vertical" flexItem />
        </div>
        <div style={{ display: 'flex' }}>
          <Box className={classes.box}>
            <span className={`${classes.icon} ${classes.ordersPending}`}>
              <MoreHorizIcon style={{ color: '#ffffff' }} />
            </span>
            <div>
              <Typography className={classes.title}>{textPedding}</Typography>
              <Typography className={classes.subtitle}>{itensPending.length}</Typography>
            </div>
          </Box>
        </div>
        <div style={{ display: 'flex' }}>
          <Box className={classes.box}>
            <span className={`${classes.icon} ${classes.separator}`}>
              <BsPersonBadgeFill size={34} color="#fff" />
            </span>
            <div>
              <Typography className={classes.title}>{textSeparator}</Typography>
              <Typography className={classes.subtitle} style={{ textTransform: 'capitalize' }}>
                {formatName(separatorName)}
              </Typography>
            </div>
          </Box>
        </div>
        <div style={{ display: 'flex' }}>
          <Box className={classes.box}>
            <span className={`${classes.icon} ${classes.separator}`}>
              <MdVisibility size={30} color="#fff" />
            </span>
            <div>
              <Typography className={classes.title}>{textRevision}</Typography>
              <Typography className={classes.subtitle} style={{ textTransform: 'capitalize' }}>
                {isReviwed}
              </Typography>
            </div>
          </Box>
        </div>
        <div style={{ display: 'flex' }}>
          <Divider className={classes.divider} orientation="vertical" flexItem />
          <Box className={classes.box}>
            <span className={`${classes.icon} ${classes.timer}`}>
              <FaClock size={30} color="#fff" />
            </span>
            <div>
              <Typography className={classes.title}>{textTimer}</Typography>
              <Typography className={classes.subtitle}>{renderTimer()}</Typography>
            </div>
          </Box>
        </div>
        <div style={{ display: 'flex' }}>
          <Divider className={classes.divider} orientation="vertical" flexItem />
          <Box className={classes.box}>
            <span className={`${classes.icon} ${classes.conferencer}`}>
              <FaUserCheck size={30} color="#fff" />
            </span>
            <div>
              <Typography className={classes.title}>{textConferencer}</Typography>
              <Typography className={classes.subtitle} style={{ textTransform: 'capitalize' }}>
                {formatName(conferencerName)}
              </Typography>
            </div>
          </Box>
        </div>
      </Carousel>
    )
  }

  return (
    <Container className={`${classes.root} ${className}`}>
      <Box className={classes.box}>
        <span className={`${classes.icon} ${classes.totalOrderIcon}`}>
          <FaShoppingCart size={30} color="#fff" />
        </span>
        <div>
          <Typography className={classes.title}>{textTotal}</Typography>
          <Typography className={classes.subtitle}>{totalItens}</Typography>
        </div>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.box}>
        <span className={`${classes.icon} ${classes.ordersFinished}`}>
          <img src={iconOrderFinished} />
        </span>
        <div>
          <Typography className={classes.title}>{textCompleted}</Typography>
          <Typography className={classes.subtitle}>{completed}</Typography>
        </div>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.box}>
        <span className={`${classes.icon} ${classes.ordersPending}`}>
          <MoreHorizIcon style={{ color: '#ffffff' }} />
        </span>
        <div>
          <Typography className={classes.title}>{textPedding}</Typography>
          <Typography className={classes.subtitle}>{itensPending.length}</Typography>
        </div>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.box}>
        <span className={`${classes.icon} ${classes.separator}`}>
          <BsPersonBadgeFill size={30} color="#fff" />
        </span>
        <div>
          <Typography className={classes.title}>{textSeparator}</Typography>
          <Typography className={classes.subtitle} style={{ textTransform: 'capitalize' }}>
            {formatName(separatorName)}
          </Typography>
        </div>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.box}>
        <span className={`${classes.icon} ${classes.separator}`}>
          <MdVisibility size={30} color="#fff" />
        </span>
        <div>
          <Typography className={classes.title}>{textRevision}</Typography>
          <Typography className={classes.subtitle} style={{ textTransform: 'capitalize' }}>
            {isReviwed}
          </Typography>
        </div>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.box}>
        <span className={`${classes.icon} ${classes.timer}`}>
          <FaClock size={30} color="#fff" />
        </span>
        <div>
          <Typography className={classes.title}>{textTimer}</Typography>
          <Typography className={classes.subtitle}>{renderTimer()}</Typography>
        </div>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.box}>
        <span className={`${classes.icon} ${classes.conferencer}`}>
          <FaUserCheck size={30} color="#fff" />
        </span>
        <div>
          <Typography className={classes.title}>{textConferencer}</Typography>
          <Typography className={classes.subtitle} style={{ textTransform: 'capitalize' }}>
            {formatName(conferencerName)}
          </Typography>
        </div>
      </Box>
    </Container>
  )
}
